import React, { forwardRef, Ref } from 'react';
import { logEventAsArray, TAnalyticArgs } from '@/analytics';
import {
  IButtonProps as IUIKitButtonProps,
  Button as UIKitButton,
} from '@mofid-securities/uikit';

export interface IButtonProps extends Omit<IUIKitButtonProps, 'ref'> {
  analytics?: TAnalyticArgs;
}

const Button = (
  { analytics, onClick, ...rest }: IButtonProps,
  ref: Ref<HTMLButtonElement>
) => {
  const handleClick: IUIKitButtonProps['onClick'] = (...args) => {
    logEventAsArray(analytics);
    if (onClick) onClick(...args);
  };

  return <UIKitButton {...rest} ref={ref} onClick={handleClick} />;
};

export default forwardRef<HTMLButtonElement, IButtonProps>(Button);
